//Imports

import React, {useRef, useState} from "react";
import Button from "@mui/material/Button";
import {TextField} from "@mui/material";
import Box from "@mui/material/Box";
import {useNavigate} from "react-router-dom";
import picture from "../content/startpage_image.png"



//Login for Intern Area Function

export default function Internlogin() {

    //Declarations and consts inside the function

    //Authenticator

    const [username, setUsername] = useState("")
    const [password, setPassword] = useState("")

    //Predefined Admincredentials
    let adminuser = "m_intern"
    let adminpass = "rosenkohl"

    const auth = () => {
        const details ={
            "Username" : username,
            "Password" : password
        }
        //console.log(details)
        if(username === adminuser && password === adminpass){
            console.log("Approved")
            navigate("/internstart")

        } else {
            console.log("keep away")
            alert("Falsches Passwort. Bitte erneut versuchen!")
        }
    }


//Login Function -> Easy login, no security standards

    const login = () =>{
        auth()

    }
//Used to redirect using the login button
    let navigate = useNavigate();

    return(
        <div>
            <div>
                <center> <img src={picture} className="center-fit" width="auto" height="auto" alt="Logo" /> </center>
                <Box
                    component="form"
                    noValidate
                    autoComplete="off"
                    className="Login-Box"
                    sx={{width: 500, height:500,
                        display: "flex", flexDirection: "column", '& .MuiTextField-root': { width: '30ch'},
                        position: 'absolute', left: '50%', top: '50%',
                        transform: 'translate(-50%, -50%)', borderRadius: 8, opacity: "60%"}}
                >
                    <h1 className="Boxfont">Login</h1>
                    <TextField
                        id="outlined-username-required"
                        onChange={e => setUsername(e.target.value)}
                        label="Username"
                        variant="outlined"
                        color="secondary"
                        helperText="Username"
                        required={"true"}
                        sx={{position: 'absolute', left: '50%', top: '45%',
                            transform: 'translate(-50%, -50%)' }}
                        inputProps={{ style: { fontFamily: 'Arial', color: 'white'}}}
                        InputLabelProps={{style:{color: "white"}}}
                        FormHelperTextProps={{style:{color: "#ba10d1"}}}/>
                    <TextField
                        id="outlined-password-input"
                        onChange={e => setPassword(e.target.value)}
                        label="Password"
                        type="password"
                        color="secondary"
                        helperText="Password"
                        required={"true"}
                        sx={{position: 'absolute', left: '50%', top: '65%',
                            transform: 'translate(-50%, -50%)',  }}
                        inputProps={{ style: { fontFamily: 'Arial', color: 'white'}}}
                        InputLabelProps={{style:{color: "white"}}}
                        FormHelperTextProps={{style:{color: "#ba10d1"}}}


                    />
                    <Button
                        variant="contained"
                        onClick={() => login()}
                        sx={{position: 'absolute', left: '50%', top: '85%',
                            transform: 'translate(-50%, -50%)', backgroundColor: "#ba10d1" , borderColor: "#ffffff",
                            "&:hover":{ backgroundColor: "#ba10d1"}
                        }}>
                        Login
                    </Button>
                </Box>
            </div>






        </div>



    )



}